import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  Box,
  ModalFooter,
  Text,
  Datepicker,
  Spacer,
  Grid,
  CardSelector,
  Button,
  SideSheet,
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import { useDispatch } from 'react-redux';
import { queryMultiTransaction } from 'redux/transaction-history/actions';
import styled from 'styled-components';

export const DateRangeWrapper = styled(Box)`
  & .flexi-datepicker {
    & .react-date-picker {
      span {
        & .react-date-picker__calendar {
          z-index: 2;
        }
      }
    }
  }

  & .flexi-datepicker {
    & .react-daterange-picker {
      span {
        & .react-daterange-picker__calendar {
          z-index: 2;
        }
      }
    }
  }
`;

export const QueryMultiTransactionModal = ({ handleModal, show, loading }) => {
  const dispatch = useDispatch();
  const [selectDate, setSelectDate] = useState(false);
  const [startFrom, setStartFrom] = useState('');

  const [processing, setProcessing] = useState('');
  const [showProcessing, setShowProcessing] = useState(false);

  const reset = () => {
    handleModal(false);
    setSelectDate(false);
    setStartFrom('');
    setProcessing('');
    setShowProcessing(false);
  };

  return (
    <SideSheet width="400px" open={show} onClose={() => reset()}>
      <Box pad="20px 30px 50px">
        <h2 style={{ fontWeight: 500 }}>Multiple Queries</h2>

        <Box margin="80px 0 20px">
          <Grid default="max-content" lr="max-content">
            <CardSelector
              name="select"
              value="1"
              view="label"
              label="Today"
              space="0"
              type="radio"
              checked={!selectDate}
              onChange={() => {
                setSelectDate(false);
                setStartFrom('');
              }}
              description="Query all Transactions done today"
            />
            <CardSelector
              name="select"
              value="1"
              view="label"
              label="Selected Date"
              type="radio"
              checked={selectDate}
              onChange={() => setSelectDate(true)}
              space="0"
              description="Query Transactions starting from a selected date"
            />
          </Grid>
          <Spacer space="20px" />
          {selectDate && (
            <DateRangeWrapper>
              <Datepicker
                style={{ gridColumn: 1 }}
                name="startDate"
                format="dd MMM yyyy"
                label="Query Transactions starting from:"
                dayPlaceholder="DD"
                monthPlaceholder="MM"
                yearPlaceholder="YYYY"
                onChange={(date) => {
                  if (!isNaN(Date.parse(date))) {
                    setStartFrom(date);
                  }
                }}
                value={startFrom}
                block
                spaceTop
              />
            </DateRangeWrapper>
          )}
          <Spacer space="20px" />
          <Button
            spaceRight
            progress={loading}
            onClick={() => {
              dispatch(
                queryMultiTransaction(
                  selectDate ? startFrom.toISOString() : '',
                  (data) => {
                    setProcessing(data);
                    setShowProcessing(true);
                  }
                )
              );
            }}
            disabled={selectDate && !startFrom ? true : false}
            iconRight={<i className="flexibull-spin4" />}
          >
            Query
          </Button>
        </Box>
      </Box>

      <Modal open={showProcessing} center={false}>
        <ModalBody width="550px">
          <Box pad="20px 30px 50px">
            <Text size="13px">{processing}</Text>
          </Box>

          <ModalFooter>
            <Box pad="20px 45px" align="right">
              <Button
                color={Theme.PrimaryColor}
                height={42}
                width={100}
                onClick={() => {
                  reset();
                }}
              >
                Ok
              </Button>
            </Box>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </SideSheet>
  );
};

QueryMultiTransactionModal.propTypes = {
  loading: PropTypes.bool,
  handleModal: PropTypes.func,
  show: PropTypes.bool,
};
